import React from "react";
import styled from "styled-components";
import Icon from "../Icon/Icon";

const StyledButton = styled.button`
  background-color: #e0e0e0; /* Use your desired shade of grey */
  color: #333; /* Text color */
  padding: 10px 15px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  :hover {
    background: #cdcdcd;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    font-size: 2vw;
    font-weight: 300;
  }
  /* Add additional styling as needed */
`;
const Text = styled.div`
  margin: 0px 10px;
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    margin: 0px 3px;
  }
`;

const GreyButton = ({
  text,
  iconName,
  onClick,
  style,
  disabled,
  title,
  className,
}) => (
  <StyledButton
    style={style}
    onClick={onClick}
    disabled={disabled}
    title={title}
    className={className}
  >
    {iconName && (
      <Icon style={{ height: "15px" }} name={iconName} alt="Button Icon" />
    )}
    {text && <Text> {text}</Text>}
  </StyledButton>
);

export default GreyButton;
